// Plan ▸ Glossary: the story's names and words, their kinds and how they're said.
export { GlossaryPage as component } from '../../views/story/GlossaryPage.tsx';
export { StoryColumn as column } from '../../views/story/StoryColumn.tsx';
export const room = 'plan';
export const page = 'glossary';
export const title = 'Glossary';
export const help = 'glossary';
export const columnTitle = 'People';
